// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import ProposalType from "./proposal-type.js"
import ProposalVoteResult from "./proposal-vote-result.js"

const modelClassData = {
  "attributes": {
    "activity_id": {
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      },
      "name": "activity_id",
      "selected_by_default": null,
      "translated": null
    },
    "election_form": {
      "column": {
        "default": "majority",
        "name": "election_form",
        "null": false,
        "type": "string"
      },
      "name": "election_form",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "proposal_type_id": {
      "column": {
        "default": null,
        "name": "proposal_type_id",
        "null": false,
        "type": "uuid"
      },
      "name": "proposal_type_id",
      "selected_by_default": null,
      "translated": null
    },
    "show_vote_count": {
      "column": {
        "default": false,
        "name": "show_vote_count",
        "null": false,
        "type": "boolean"
      },
      "name": "show_vote_count",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "text": {
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      },
      "name": "text",
      "selected_by_default": null,
      "translated": null
    },
    "translated_election_form": {
      "column": null,
      "name": "translated_election_form",
      "selected_by_default": false,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": false,
      "translated": null
    },
    "proposal_votes_count": {
      "column": {
        "default": 0,
        "name": "proposal_votes_count",
        "null": false,
        "type": "integer"
      },
      "name": "proposal_votes_count",
      "selected_by_default": null,
      "translated": null
    },
    "proposal_vote_tokens_count": {
      "column": {
        "default": 0,
        "name": "proposal_vote_tokens_count",
        "null": false,
        "type": "integer"
      },
      "name": "proposal_vote_tokens_count",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Proposal",
  "collectionKey": "proposals",
  "collectionName": "proposals",
  "i18nKey": "proposal",
  "camelizedLower": "proposal",
  "name": "Proposal",
  "nameDasherized": "proposal",
  "pluralName": "proposals",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "AgendaItemElement",
      "collectionName": "agenda_item_elements",
      "foreignKey": "proposal_id",
      "name": "agenda_item_elements",
      "macro": "has_many",
      "resource_name": "AgendaItemElement",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "proposal_contacts"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "ProposalContact",
      "collectionName": null,
      "foreignKey": "proposal_id",
      "name": "proposal_contacts",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ProposalType",
      "collectionName": "proposal_types",
      "foreignKey": "proposal_type_id",
      "name": "proposal_type",
      "macro": "belongs_to",
      "resource_name": "ProposalType",
      "through": null
    },
    {
      "className": "ProposalVoteResult",
      "collectionName": "proposal_vote_results",
      "foreignKey": "proposal_id",
      "name": "proposal_vote_result",
      "macro": "has_one",
      "resource_name": "ProposalVoteResult",
      "through": null
    },
    {
      "className": "ProposalVote",
      "collectionName": null,
      "foreignKey": "proposal_id",
      "name": "proposal_votes",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "activity_id",
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "election_form",
      "column": {
        "default": "majority",
        "name": "election_form",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_activity_id",
      "column": {
        "default": null,
        "name": "old_activity_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "proposal_type_id",
      "column": {
        "default": null,
        "name": "proposal_type_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "proposal_vote_tokens_count",
      "column": {
        "default": 0,
        "name": "proposal_vote_tokens_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "proposal_votes_count",
      "column": {
        "default": 0,
        "name": "proposal_votes_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "public_access",
      "column": {
        "default": false,
        "name": "public_access",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "show_vote_count",
      "column": {
        "default": false,
        "name": "show_vote_count",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "text",
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ProposalType",
      "collectionName": "proposal_types",
      "foreignKey": "proposal_type_id",
      "name": "proposal_type",
      "macro": "belongs_to",
      "resource_name": "ProposalType",
      "through": null
    },
    {
      "className": "ProposalVoteResult",
      "collectionName": "proposal_vote_results",
      "foreignKey": "proposal_id",
      "name": "proposal_vote_result",
      "macro": "has_one",
      "resource_name": "ProposalVoteResult",
      "through": null
    }
  ],
  "paramKey": "proposal",
  "primaryKey": "id"
}

/** Frontend model for Proposal. */
export default class Proposal extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  activityId() {
    return this.readAttributeUnderscore("activity_id")
  }

  /** @returns {boolean} */
  hasActivityId() {
    const value = this.activityId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  electionForm() {
    return this.readAttributeUnderscore("election_form")
  }

  /** @returns {boolean} */
  hasElectionForm() {
    const value = this.electionForm()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string} */
  proposalTypeId() {
    return this.readAttributeUnderscore("proposal_type_id")
  }

  /** @returns {boolean} */
  hasProposalTypeId() {
    const value = this.proposalTypeId()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  showVoteCount() {
    return this.readAttributeUnderscore("show_vote_count")
  }

  /** @returns {boolean} */
  hasShowVoteCount() {
    const value = this.showVoteCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  text() {
    return this.readAttributeUnderscore("text")
  }

  /** @returns {boolean} */
  hasText() {
    const value = this.text()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedElectionForm() {
    return this.readAttributeUnderscore("translated_election_form")
  }

  /** @returns {boolean} */
  hasTranslatedElectionForm() {
    const value = this.translatedElectionForm()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {number} */
  proposalVotesCount() {
    return this.readAttributeUnderscore("proposal_votes_count")
  }

  /** @returns {boolean} */
  hasProposalVotesCount() {
    const value = this.proposalVotesCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  proposalVoteTokensCount() {
    return this.readAttributeUnderscore("proposal_vote_tokens_count")
  }

  /** @returns {boolean} */
  hasProposalVoteTokensCount() {
    const value = this.proposalVoteTokensCount()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  findOrCreateProposalVoteToken(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "find_or_create_proposal_vote_token",
        primaryKey: this.primaryKey(),
        collectionName: "proposals",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  generateAndProcessResult(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "generate_and_process_result",
        primaryKey: this.primaryKey(),
        collectionName: "proposals",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  generateAndShowResult(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "generate_and_show_result",
        primaryKey: this.primaryKey(),
        collectionName: "proposals",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./proposal-type.js").default | null} */
  proposalType() {
    return this._readBelongsToReflection({modelClass: ProposalType, reflectionName: "proposal_type"})
  }

  /** @returns {Promise<import("./proposal-type.js").default | null>} */
  loadProposalType() {
    if (!("proposalTypeId" in this)) throw new Error("Foreign key method wasn't defined: proposalTypeId")

    const id = this.proposalTypeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "proposal_type",
        model: this,
        modelClass: ProposalType
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./proposal-type.js").default | null>} */
  ensureProposalTypeLoaded() {
    return this.ensureAssociationLoaded("proposal_type")
  }

  /** @returns {import("./proposal-vote-result.js").default | null} */
  proposalVoteResult() {
    return this._readHasOneReflection({modelClass: ProposalVoteResult, reflectionName: "proposal_vote_result"})
  }

  /** @returns {Promise<import("./proposal-vote-result.js").default | null>} */
  loadProposalVoteResult() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["proposal_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "proposal_vote_result",
        model: this,
        modelClass: ProposalVoteResult
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./proposal-vote-result.js").default | null>} */
  ensureProposalVoteResultLoaded() {
    return this.ensureAssociationLoaded("proposal_vote_result")
  }
}
